import {Stack} from "@mui/material";

import FilterPendingBksBySegment from "./filter-pending-bks-by-seg/FilterPendingBksBySegment";
import TablePendingBksBySeg from "./table-pending-bks-by-seg/TablePendingBksBySeg";

/**
 * Content component in tab Pending Bookings by Segment and Category
 * Contains filter and table
 */
const pendingBksBySegTab = () => {
    return (
        <Stack rowGap={2}  px= {0} py={3}>
            <FilterPendingBksBySegment />
            <TablePendingBksBySeg />
        </Stack>
    );

}

export default pendingBksBySegTab;
